import { AxiosPromise } from 'axios';
import httpClient from 'api/httpClient';
import { PayrocMerchantAccount } from './addPayrocMerchantAccount';

export interface EditPayrocMerchantAccountPayload {
  merchantId: string;
  payrocMerchantAccountId: number;
  businessId: number;
}

export const editPayrocMerchantAccount = ({
  merchantId,
  payrocMerchantAccountId,
  businessId,
}: EditPayrocMerchantAccountPayload): AxiosPromise<PayrocMerchantAccount> => {
  return httpClient({
    method: 'PATCH',
    url: `/super-admin/businesses/${businessId}/payroc/merchants/update`,
    data: {
      merchantId,
      payrocMerchantAccountId,
    },
  });
};
